import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, OnInit, Inject, AfterViewInit } from '@angular/core';

@Component({
  selector: 'bilder-karussell',
  templateUrl:  './bilder-karussell.component.html',
  styleUrls: ['./bilder-karussell.component.css'],
})

export class BilderKarussellComponent implements OnInit, AfterViewInit {

  public plattform = this.data.data.plattform
  public pwaInstallManual = {
    'ANDROID': [
      'im Chrome das <strong>Menü</strong>, über das Symbol mit den drei Punkten, öffnen (Burgermenü am oberen rechten Rand)',
      'im Menü die Option<br> <strong>"Zum Startbildschirm hinzufügen"</strong> auswählen',
      'fortfahren mit <strong>"Installation"</strong> oder <br><strong>"Verknüpfung erstellen"</strong>',
      'mit <strong>"Installieren"</strong> den Installationsvorgang auf dem Hauptmenü abschließen',
      'nach Wunsch das Icon der Web-Bestell-App vom Hauptmenü <strong>"Zum Start hinzufügen"</strong>',
      '<strong>"Verknüpfung erstellen"</strong> auswählen,<br> nach Wunsch den App-Namen ändern und mit <strong>"Hinzufügen"</strong> den Vorgang abschließen',
      'das Icon der <strong>"Web-Bestell-App"</strong> ist auf dem Startbildschirm platziert und mit dem Symbol des verknüpften Browsers markiert'
    ],
    'SAFARI': [
      '1. Im Safari das <strong>Teilen-Menü</strong> öffnen (Menüleiste im untereren Bereich).',
      '2. Im Menü die Option <strong>„Zum Home-Bildschirm“</strong> auswählen.',
      '3. Nach Wunsch den App-Namen zum Icon ändern und mit <strong>"Hinzufügen"</strong> den Installationsvorgang abschließen.'
    ]
  }
  public aktiv = 1

  constructor(
    public dialogRef: MatDialogRef<BilderKarussellComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  public close(){
    this.dialogRef.close()
  }

  public bildWechseln(zahl){
    this.aktiv = zahl
  }
}

